export default __webpack_public_path__ + "static/media/icon-load-profile.3fa2ab21.svg";